import UpdateIdentityEmailLink from "./UpdateIdentityEmailLink"

export default UpdateIdentityEmailLink
